package com.example.mystybag.core.expected

/**
 * Result of a successful Apple Sign-In flow returned by [signInWithApple].
 *
 * `email` may be empty on **subsequent** sign-ins because Apple only returns the
 * email (and `firstName`/`lastName`) on the **first** authorization for a given
 * Services ID + user. On repeat sign-ins, identify the user by the `sub` claim
 * inside `idToken` and look up the previously stored email/name on your backend.
 *
 * Apple does NOT provide a profile photo URL — that field intentionally does
 * not exist here (unlike [GoogleSignInResult]).
 */
data class AppleSignInResult(
    val email: String,
    val idToken: String,
    val firstName: String? = null,
    val lastName: String? = null,
)
